import endpoints from "hooks/api/endpoints";
import useApiGet, { SWR_OPTION } from "hooks/api/useApiGet";
import ConfigDto from "types/ConfigDto";
import IndividualItemResponse from "types/IndividualItemResponse";

interface Params {
  id?: string | null | undefined;
  suspendRequest?: boolean;
}

export default function useGetConfig(params?: Params) {
  const { id, suspendRequest } = params || {};

  const { result, ...rest } = useApiGet<IndividualItemResponse<ConfigDto>>(
    suspendRequest
      ? ""
      : id
        ? endpoints.getConfigByProjectId(id)
        : endpoints.getConfig(),
    { swrOptions: SWR_OPTION.CALL_ONCE },
  );

  return { config: result?.data, ...rest };
}
